import Component from '@bythepixel/component-loader';

export default class buildTrailerLink extends Component {
  static selector = '[comp-build-trailer-link]'

  #originalUrl = null;
  #exterParam = '';
  #extruParam = '';

  constructor(...args) {
    super(...args);
    this.#originalUrl = this.$container.href;
    this.events();
  }

  events() {
    this.$subscribe('option-selector:choose-exterior', ({ exterior }) => {
      this.#exterParam = `exterior=${exterior}`;
      this.addParamsToLink();
    });
    this.$subscribe('option-selector:choose-extrusion', ({ extrusion }) => {
      this.#extruParam = `extrusion=${extrusion}`;
      this.addParamsToLink();
    });
  }

  addParamsToLink() {
    this.$container.href = `${this.#originalUrl}?${this.#exterParam}&${this.#extruParam}`;
  }
}
